import React, { useEffect, useState } from "react";
import Nav from "./Nav";
import arrowleft from "../assets/images/arrow-left.png";
import DropdownRight from "./DropdownRight";
import { useLocation, useNavigate } from "react-router-dom";
import { Formik } from "formik";
import http from "../services/http";
import GetStorage from "../services/Storage";
import { ToastContainer } from "react-toastify";
import { showToast } from "./ShowToast";
import ReactInputMask from "react-input-mask";

function EditParentDetails(props) {
  const location = useLocation();
  const navigate = useNavigate();

  const { id } = location.state;
  const [team, setTeam] = useState([]);
  const [teamID, setTeamId] = useState([]);

  const token = GetStorage.get("xAuthToken");
  useEffect(() => {
    AdminTeam();
    if (id) {
      userGet();
    }
    //AdminTeamId();
  }, []);

  const [error, setError] = useState("");
  const [firstname, setfirstName] = useState("");
  const [lastname, setLastname] = useState("");
  const [gender, setGender] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [messages, setMessages] = useState("");
  const [team_id, setTeam_id] = useState("");
  const [group_id, setGroup_id] = useState("");
  const [parent, setParent] = useState({});

  const userGet = () => {
    http
      .get(`api/admin/parent/${id}?token=${token}`)
      .then((res) => {
        setParent(res.data);

        // setGroup_id(res.data.group_id);
        setfirstName(res.data.firstname);
        setLastname(res.data.lastname);
      })
      .catch((error) => {
        console.log("error ", error.response.data.errors);
      });
  };
  const AdminTeam = () => {
    http
      .get(`api/admin/team?token=${token}`)
      .then((res) => {
        console.log("admin team", res.data);
        setTeam(res.data);
        // if (!id) {
        //   setTeam_id(res.data[0].id);
        // }
      })
      .catch((error) => {
        console.log("error ", error.response.data.errors);
      });
  };
  // const AdminTeamId = () => {
  //   http
  //     .get(`api/teamgroup/byteam/${swimmer.team_id}?token=${token}`)
  //     .then((res) => {
  //       console.log("admin team id", res.data);
  //       setTeamId(res.data);
  //     })
  //     .catch((error) => {
  //       console.log("error ", error.response.data.errors);
  //     });
  // };

  const handleChanges = (event) => {
    console.log("on change value", event.target.value);
    setTeam_id(event.target.value);
    // http
    //   .get(`api/teamgroup/byteam/${event.target.value}?token=${token}`)
    //   .then((res) => {
    //     console.log("admin team select", res.data);
    //     setTeamId(res.data);
    //     if (res.data.length) {
    //       setGroup_id(res.data[0].id);
    //     }
    //   })
    //   .catch((error) => {
    //     console.log("error ", error.response.data.errors);
    //   });
  };

  const onSubmit = async (values) => {
    console.log("value of submit button ===>", parent);

    if (parent.id) {
      http
        .put(`api/admin/parent/editParentadmin?token=${token}`, {
          id: parent.id,
          firstname: parent.firstname,
          lastname: parent.lastname,
          email: parent.email,
          gender: parent.gender,
          phone: parent.phone?.replaceAll("_", "").length >= 10 ? parent.phone : null,
          createdBy: 'admin'
          //team_id: team_id,
        })
        .then((res) => {
          console.log("response", res.data);
          showToast("success", res.data.message);
          setTimeout(() => {
            navigate(-1);
          }, 3000);
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data.errors) {
              for (let key in error.response.data.errors) {
                setError(error.response.data.errors[key]);
                showToast("error", error.response.data.errors[key]);
              }
            } else if (error.response.data.message) {
              showToast("error", error.response.data.message);

              setError(error.response.data.message);
            }
          }
        });

    } else {
      http
        .post(`api/admin/parent/addparentAdmin?token=${token}`, {
          firstname: parent.firstname,
          lastname: parent.lastname,
          email: parent.email,
          gender: parent.gender,
          phone: parent.phone?.replaceAll("_", "").length >= 10 ? parent.phone : null,
          createdBy: 'admin'
          //team_id: team_id,
        })
        .then((res) => {
          console.log("response", res.data);
          showToast("success", res.data.message);
          setTimeout(() => {
            navigate(-1);
          }, 3000);
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data.errors) {
              for (let key in error.response.data.errors) {
                setError(error.response.data.errors[key]);
                showToast("error", error.response.data.errors[key]);
              }
            } else if (error.response.data.message) {
              showToast("error", error.response.data.message);

              setError(error.response.data.message);
            }
          }
        });
    }

  };

  const onChangeProp = (event, key) => {
    parent[key] = event.target.value
    setParent(parent);
  };


  const GroupHandler = (event) => {
    console.log("group handler", event.target.value);
    setGroup_id(event.target.value);
  };

  const handleVideoLinkSend = () => {
     http
      .post(`api/admin/parent/text-email-send?token=${token}`,{id:parent.id,email:parent.email,phone:parent.phone})
      .then((res) => {
          showToast("success", res.data.message);
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              setError(error.response.data.errors[key]);
              showToast("error", error.response.data.errors[key]);
            }
          } else if (error.response.data.message) {
            showToast("error", error.response.data.message);

            setError(error.response.data.message);
          }
        }
      });
  }

  return (
    <>
      <body>
        <div className="wrapper">
          <Nav />
          <div id="content">
            <header>
              <div className="dashboard_header">
                <div className="left-side d-flex ">
                  <button
                    onClick={() => navigate(-1)}
                    type="button"
                    id="sidebarCollapse"
                    className="btn btn-link  "
                  >
                    <img src={arrowleft} className="img-fluid" />{" "}
                  </button>
                  <h1>Edit Details</h1>{" "}
                </div>
                <DropdownRight />
              </div>
            </header>

            <Formik
              initialValues={parent}
              onSubmit={onSubmit}>
              {({ values, handleSubmit, setFieldValue, handleChange }) => (
                <>
                  <div className="dashbord_content">
                    <div className="dashobord_inner new_team_add">
                      <h5 className="my-3">General Info</h5>
                      <form onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="col-md-4 col-sm-6">
                            <div className="fomr-group">
                              <label> First Name</label>
                              <input
                                type="text"
                                id="firstname"
                                name="firstname"
                                onChange={(e) => {
                                  handleChange(e);
                                  onChangeProp(e, "firstname")
                                }}
                                value={parent.firstname}
                                className="custom_input form-control"
                              />
                            </div>
                          </div>
                          <div className="col-md-4 col-sm-6">
                            <div className="fomr-group">
                              <label> Last Name</label>
                              <input
                                type="text"
                                id="lastname"
                                name="lastname"
                                onChange={(e) => {
                                  handleChange(e);
                                  onChangeProp(e, "lastname")
                                }}
                                value={parent.lastname}
                                className="custom_input form-control"
                              />
                            </div>
                          </div>
                          <div className="col-md-4 col-sm-6">
                            <div className="fomr-group">
                              <label> Gender</label>
                              <select
                                id="gender"
                                name="gender"
                                onChange={(e) => {
                                  handleChange(e);
                                  onChangeProp(e, "gender")
                                }}
                                value={parent.gender}
                                className="form-control custom_input w-100"
                              >
                                <option
                                  value="MALE"
                                  selected={
                                    parent.gender === "MALE" ? true : false
                                  }
                                >
                                  Male
                                </option>
                                <option
                                  value="FEMALE"
                                  selected={
                                    parent.gender === "FEMALE" ? true : false
                                  }
                                >
                                  Female
                                </option>
                              </select>
                            </div>
                          </div>
                          <div className="col-md-4 col-sm-6">
                            <div className="fomr-group">
                              <label> Email Address</label>
                              <input
                                type="text"
                                id="email"
                                name="email"
                                onChange={(e) => {
                                  handleChange(e);
                                  onChangeProp(e, "email")
                                }}
                                value={parent.email}
                                className="custom_input form-control"
                              />
                            </div>
                          </div>
                          <div className="col-md-4 col-sm-6">
                            <div className="fomr-group">
                              <label> Phone</label>
                              {/* <input
                                type="text"
                                id="phone"
                                name="phone"
                                onChange={(e) => {
                                  handleChange(e);
                                  onChangeProp(e, "phone")
                                }}
                                value={parent.phone}
                                className="custom_input form-control"
                              /> */}
                              <ReactInputMask placeholder="+1 999-999-9999" className="custom_input form-control"
                                id="phone"
                                name="phone" mask={"+1 999-999-9999"}
                                onChange={e => {
                                  let phone = e.currentTarget.value.replace(/\(|\)|\s|-/g, "")
                                  setFieldValue('phone', phone)
                                  if (phone.length >= 12 || phone.length >= 10) {
                                    values['phone'] = phone;
                                    parent["phone"] = phone
                                    setParent(parent);
                                  }

                                }}
                                value={parent.phone}
                              >
                              </ReactInputMask>
                            </div>
                          </div>
                          {/* {!parent.id && <div className="col-md-4 col-sm-6">
                            <div className="fomr-group">
                              <label> Team</label>
                              <select
                                onChange={handleChanges}
                                name="Team"
                                className="form-control custom_input w-100"
                              >
                                {team?.map((item, i) => (
                                  <option
                                    key={i}
                                    value={item.id}
                                    selected={
                                      item.id === parent.team_id ? true : false
                                    }
                                  >
                                    {item.name}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>} */}
                          {/* <div className="col-md-4 col-sm-6">
                            <div className="fomr-group">
                              <select
                                onChange={GroupHandler}
                                name="group"
                                className="form-control custom_input w-100"
                              >
                                {teamID?.map((item, i) => (
                                  <option
                                    key={i}
                                    value={item.id}
                                    selected={
                                      item.id === swimmer.group_id
                                        ? true
                                        : false
                                    }
                                  >
                                    {item.name}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div> */}
                          <div className="col-12 d-flex justify-content-end">
                            <div className="btn_wraper d-flex Permissions_text align-item-center mt_40 mb_30">
                              <button
                                onClick={() => navigate(-1)}
                                type="button"
                                className=" them_btn_ouline  "
                              >
                                Cancel
                              </button>
                              <button
                                type="button"
                                className="them_btn "
                                onClick={onSubmit}
                              >
                                Save
                              </button>
                              <button
                                type="button"
                                className="video-link-btn-parent"
                                onClick={handleVideoLinkSend}
                              >
                                Send Videos Link
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </>
              )}
            </Formik>
          </div>
        </div>

        <div
          className="modal fade starrating new_team_add"
          id="new_team_add"
          data-backdrop="static"
          data-keyboard="false"
          tabindex="-1"
          aria-labelledby="new_team_add"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="new_team_add">
                  Super Admin Login
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  {" "}
                  <span aria-hidden="true">&times;</span>{" "}
                </button>
              </div>
              <div className="modal-body">
                <div className="raing_star">
                  <p>Please enter your login credentials to proceed.</p>
                  <div className="row mt-3">
                    <div className="col-12">
                      <div className="fomr-group">
                        <input
                          type="email"
                          className="form-control"
                          placeholder="Email ID"
                        />{" "}
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="fomr-group">
                        <input
                          type="Password"
                          className="form-control"
                          placeholder="Password"
                        />{" "}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer border-top-0">
                  <button type="button" className="them_btn_ouline ">
                    Cancel
                  </button>
                  <button type="button" className="them_btn ">
                    Continue
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </body>
      <ToastContainer />
    </>
  );
}

export default EditParentDetails;
